import CustomButton from "components/button";
import SelectInput, { DynamicOption } from "components/fields/SelectInput";
import CustomModal from "components/modals";
import { useState } from "react";
import { MdDelete } from "react-icons/md";
import { reqFunction } from "utils/API";
import { renderToast } from "utils/globalUtils";
import { ProjectObject } from "views/projects";
import DeleteForm from "./DeleteForm";
import { useDisclosure } from "@chakra-ui/hooks";

export type ProjectManagers = {
  admin_id: string;
  admin_name: string;
  admin_lastname: string;
  admin_phone: string;
  middel_admin_projects: ProjectObject[];
};
interface AssignProjectFormProps {
  projectSelectData?: DynamicOption[] | null;
  onClose: Function;
  middleId: string;
  ProjectManagers: ProjectManagers[];
  middleProjectRefetch: Function;
  middleProjectIds: string[];
  // updateTable: any;
}
const AssignProjectForm = (props: AssignProjectFormProps) => {
  const [project, setProject] = useState<DynamicOption>(null);

  const {
    projectSelectData,
    onClose,
    middleId,
    ProjectManagers,
    middleProjectRefetch,
    middleProjectIds,
    // updateTable,
  } = props;

  const {
    isOpen: isDeleteConfirmOpen,
    onOpen: onDeleteConfirmOpen,
    onClose: onDeleteConfirmClose,
  } = useDisclosure();

  const [projectToDelete, setProjectToDelete] = useState<ProjectObject | null>(
    null
  );
  const handleDeleteClick = (project: ProjectObject) => {
    setProjectToDelete(project);
    onDeleteConfirmOpen();
  };

  const deleteMiddleProject = async (pid: string) => {
    const selectedMiddle = ProjectManagers.find(
      (admin) => admin.admin_id === middleId
    );
    if (!selectedMiddle) return;

    const newProjectList = selectedMiddle.middel_admin_projects.filter(
      (project) => project.water_meter_project_id !== pid
    );
    const middleNewProjectIds = newProjectList.map(
      (project) => project.water_meter_project_id
    );

    const response = await reqFunction("middle/admin/edit/data", {
      middle_admin_id: middleId,
      project_ids: middleNewProjectIds,
      water_meter_ids: [],
    });

    if (response.code === 200) {
      renderToast("تغییرات در تخصیص پروژه با موفقیت انجام شد", "success");
      middleProjectRefetch();
      setProject(null);
      onDeleteConfirmClose();
    } else {
      renderToast(
        response?.farsi_message || "در تخصیص پروژه خطایی رخ داده",
        "err"
      );
    }
  };

  const renderMiddleInfo = () => {
    let selectedMiddle = ProjectManagers?.filter(
      (admin) => admin.admin_id === middleId
    );

    return (
      <>
        {selectedMiddle?.length > 0 ? (
          selectedMiddle[0].middel_admin_projects.map((p, i) => (
            <div
              key={p.water_meter_project_id}
              className="flex items-center justify-between border-b py-2"
            >
              <span className="">{p.water_meter_project_name}</span>{" "}
              <span className="">
                <CustomButton
                  onClick={() => {
                    handleDeleteClick(p);
                  }}
                  icon={<MdDelete />}
                  color="red"
                  extra="!p-2"
                />
              </span>
            </div>
          ))
        ) : (
          <div className="py-2  text-navy-700  dark:text-white">
            پروژه ای به این کاربر تخصیص داده نشده است !!!
          </div>
        )}
      </>
    );
  };
  const assignProject = async () => {
    if (project) {
      let newProjectList = [...middleProjectIds, project.value];
      let response = await reqFunction("middle/admin/add/data", {
        middle_admin_id: middleId,
        project_ids: newProjectList,
        water_meter_ids: [],
      });
      if (response.code === 200) {
        renderToast("تخصیص پروژه با موفقیت انجام شد", "success");
        // updateTable();
        middleProjectRefetch();
        // onClose();
        setProject(null);
        // setOrderType(null);
      } else {
        renderToast(
          response?.farsi_message
            ? response.farsi_message
            : "در تخصیص پروژه خطایی رخ داده",
          "err"
        );
      }
    } else {
      renderToast("تمامی موارد را انتخاب کنید", "warn");
    }
  };
  return (
    <>
      <div className=" py-2">
        <div className="text-md font-bold text-navy-700 dark:text-white">
          پروژه های مدیر
        </div>
        <div className="">{renderMiddleInfo()}</div>
      </div>
      <div className=" flex flex-col space-y-4">
        <SelectInput
          label="نام پروژه"
          placeholder="پروژه مورد نظر را انتخاب کنید"
          dynamicOptions={projectSelectData}
          state={project}
          setState={setProject}
        />
        <div className="form-actions flex flex-row items-center justify-end ">
          <CustomButton onClick={onClose} text="بستن" color="red" />
          <CustomButton
            onClick={() => assignProject()}
            text={`ارسال`}
            color="green"
            extra="!ml-0"
          />
        </div>
      </div>
      <CustomModal
        isOpen={isDeleteConfirmOpen}
        onClose={onDeleteConfirmClose}
        title={""}
        modalType="form"
        information={null}
        modalForm={
          <DeleteForm
            deleteType="project"
            projectDeleted={projectToDelete}
            onClose={onDeleteConfirmClose}
            deleteFunction={() =>
              deleteMiddleProject(projectToDelete?.water_meter_project_id || "")
            }
          />
        }
      />
    </>
  );
};
export default AssignProjectForm;
